import { secureGet } from './http-module';

let notificationData = {};
const NOTIFICATION_URI =
  '/api/bff-notification/private/message?messageTypeId=equals,';

export const getNotificationService = (messageTypeId) => {
    return secureGet(NOTIFICATION_URI + messageTypeId).then(({ data }) => {
    notificationData = data.content;
    return notificationData;
  });
};
